"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _component = _interopRequireDefault(require("../component"));

var _sift = _interopRequireDefault(require("sift"));

var _propFiller = _interopRequireDefault(require("../compiler/prop-filler"));

var _componentFillerProps = _interopRequireDefault(require("../component/component-filler-props"));

var _registrar = _interopRequireDefault(require("../compiler/registrar"));

var _globals = _interopRequireDefault(require("../globals"));

var _access = _interopRequireDefault(require("../access"));

var Action =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Action, _Component);

  function Action() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Action);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Action)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'Action');
    return _this;
  }

  (0, _createClass2.default)(Action, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(Action.prototype), "_create", this).call(this, props); // For mocking

      this._registrar = _registrar.default;
      this._globals = _globals.default;
      this._access = _access.default;
      this._componentFillerProps = new _componentFillerProps.default();
      this._fillerProps = null;
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'if',
            component: 'WhereField'
          }, {
            name: 'actions',
            component: 'Field'
          }, {
            name: 'else',
            component: 'Field'
          }, {
            name: 'layer',
            component: 'TextField'
          }, {
            name: 'detached',
            component: 'BooleanField'
          }]
        }
      });
    } // Abstract method
    // async act(/* props */) {}

  }, {
    key: "_fill",
    value: function _fill(prop) {
      var propFiller = new _propFiller.default(this._fillerProps); // Fill with props from coponent first so that we define default values in the component like
      // {{fields.to.value}} that are then filled via the second fill.

      prop = propFiller.fill(prop);
      prop = propFiller.fill(prop); // Yes, this duplicate is needed!

      return prop;
    }
  }, {
    key: "_getFilled",
    value: function _getFilled(names) {
      var prop = (0, _get2.default)((0, _getPrototypeOf3.default)(Action.prototype), "get", this).call(this, names);
      return prop === undefined ? undefined : this._fill(prop);
    }
  }, {
    key: "get",
    value: function get(names) {
      return this._getFilled(names);
    }
  }, {
    key: "_setFillerProps",
    value: function _setFillerProps(props) {
      // getFillerProps() wraps the props in a Getter so that the values can be retrieved dynamically,
      // allowing for things like retrieving data from deely nested components.
      this._fillerProps = this._componentFillerProps.getFillerProps(props);
    }
  }, {
    key: "_setWhereProps",
    value: function _setWhereProps(where, props) {
      // getWhereProps() resolves all the properties in the query and populates _whereProps. This
      // allows us to dynamically query data in deeply nested components.
      this._whereProps = this._componentFillerProps.getWhereProps(where, props);
    }
  }, {
    key: "run",
    value: function () {
      var _run = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(props) {
        var where, shouldRun, actions, sifted, args, i;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._setFillerProps(props);

                where = this.get('if');
                shouldRun = true;
                actions = null;

                if (where) {
                  this._setWhereProps(where, props);

                  sifted = (0, _sift.default)(where, [this._whereProps]);

                  if (sifted.length === 0) {
                    // Condition failed
                    if (this.get('else')) {
                      actions = this.get('else');
                    } else {
                      // The condition failed and there is nothing to execute
                      shouldRun = false;
                    }
                  } else {
                    // Condition met
                    actions = this.get('actions');
                  }
                } else {
                  actions = this.get('actions');
                }

                if (!shouldRun) {
                  _context.next = 21;
                  break;
                }

                if (!actions) {
                  _context.next = 20;
                  break;
                }

                args = null;
                _context.t0 = _regenerator.default.keys(actions);

              case 9:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 17;
                  break;
                }

                i = _context.t1.value;

                if (!args && props && props.arguments) {
                  args = props.arguments;
                }

                _context.next = 14;
                return actions[i].run((0, _objectSpread2.default)({}, props, {
                  arguments: args,
                  parent: this,
                  context: props && props.context
                }));

              case 14:
                args = _context.sent;
                _context.next = 9;
                break;

              case 17:
                return _context.abrupt("return", args);

              case 20:
                return _context.abrupt("return", this.act(props));

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function run(_x) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);
  return Action;
}(_component.default);

exports.default = Action;